function scale(value, inMin, inMax, outMin, outMax) {
  return (((value - inMin) * (outMax - outMin) / (inMax - inMin)) + outMin)
}

export default scale